import { format } from 'date-fns';
import { parseApiDate } from '@gettactic/helpers/src/date-time/index';
import { toDate } from "date-fns-tz";
import { cn } from '@gettactic/helpers';

export const isoToZonedDate = (isoDate: string, timeZone: string): Date => {
  return toDate(isoDate.replace("Z", ""), {timeZone: timeZone})
}

export const DayDate = ({
  apiDate,
  tz,
  className
}: {
  apiDate: string,
  tz?: string,
  className?: string
}) => {
  let date = parseApiDate(apiDate);
  if(tz) {
    date = isoToZonedDate(apiDate, tz);
  }
  return (
    <div className={cn('space-x-2', className)}>
      <Weekday date={date} />
      <DateNumber date={date} />
    </div>
  );
};

const Weekday = ({
  date
}: {
  date: Date;
}) => {
  const day = format(date, 'eee');
  return <span className='font-bold' style={{ fontSize: 'inherit' }}>
    {day}
  </span>;
};

const DateNumber = ({
  date
}: {
  date: Date;
}) => {
  const day = format(date, 'd');
  return <span className='text-neutral-500' style={{ fontSize: 'inherit' }}>
    {day}
  </span>;
};
